import XLSX from 'xlsx';

export function jsonToExcel(rows, columns, wsName, filename) {
  var wb = XLSX.utils.book_new();
  var ws = XLSX.utils.json_to_sheet(rows);

  var wscols = [];
  let cols = [];

  columns.forEach(col => {
    cols.push(col.field);
  });

  for (var i = 0; i < cols.length; i++) {  // columns length added
    wscols.push({ wch: cols[i].length + 10 });
  }

  ws['!cols'] = wscols;

  XLSX.utils.book_append_sheet(wb, ws, wsName);

  return XLSX.writeFile(wb, filename);
}

export function formatOrdersReport(results) {
  let rows = [];

  results.forEach(row => {
    rows.push({
      "Order Date": row.orderDate,
      //"Order ID": row.orderId,
      "Order ID": row.orderReference,
      //"Item ID": row.itemId,
      "Item ID": row.itemSKU,
      "Item Name": row.itemName,
      "Product Description": row.productDescription,
      "Qty": row.qty,
      "Campaign Item": row.campaignItem,
      "Program Name": row.programName,
      "Account Name": row.accountName,
      "Status": row.status,
      "RD Id": row.rdId,
      "RD Name": row.rdName,
      "RD Email": row.rdEmail,
      "Instructions": row.instructions
    });
  });

  return rows;
}

export function formatAging(results) {
  let rows = [];

  results.forEach(row => {
    rows.push({
      "Order Date": row.orderDate,
      //"Order ID": row.id,
      "Order ID": row.orderReference,
      //"Item ID": row.itemId,
      "Item ID": row.itemSKU,
      "Item Name": row.itemName,
      "Product Description": row.productDescription,
      "Qty": row.qty,
      "Campaign Item": row.campaignItem,
      "Program Name": row.programName,
      "Account Name": row.accountName,
      "Status": row.status,
      "Order Age": row.age,
      "RD Id": row.rdId,
      "RD Name": row.rdName,
      "RD Email": row.rdEmail,
      "Instructions": row.instructions
    });
  });

  return rows;
}

export function formatInventory(results) {
  let rows = [];

  results.forEach(row => {
    rows.push({
      "Regional Director": row.accountManager,
      "Account Name": row.accountName,
      //"ARIQ Order ID": row.orderId,
      "ARIQ Order ID": row.orderReference,
      "Order Placed Date": row.orderPlacedDate,
      "ARIQ Allocated Order ID": row.allocatedOrderId,
      "Order Allocated Date": row.orderAllocatedDate,
      //"Product ID": row.productId,
      "Product ID": row.productSku,
      "Product Ordered": row.productName,
      "Product Description": row.productDescription,
      "Campaign Item?": row.campaignItem,
      "Campaign Name": row.programName,
      "Ordered Amount": isNumUndefined(row.qtySelected, row),
      "Allocated Amount": row.qtyAllocated,
      "Bill-To ID": row.billToId,
      "Ship-To ID": row.shipToId,
      "Delivery Location": row.shipTo,
      "Ship-To Name": row.accountName,
      "Ship-To Address": row.shipToAddress,
      "Ship-To City": row.shipToCity,
      "Ship-To State": row.shipToState,
      "Ship-To Zip": row.shipToZip,
      "Receiving Contact Name": row.receivingContactName,
      "Receiving Contact Phone": row.receivingContactPhone,
      "Receiving Contact Email": row.receivingContactEmail,
      "Web Portal": row.webPortal,
      "Delivery Window": row.deliveryWindow,
      "IS A PO REQUIRED FOR DELIVERY? (YES/NO)": row.poRequired ? 'YES' : 'NO',
      "PO No (if required for delivery)": row.poNum,
      "PO Date for Delivery": row.poDate,
      "Special Instructions": row.instructions,
      "HRMS Shipping Code": row.hrmsCode,
      "HRMS Release Number": row.hrmsReleaseNumber,
      "Qty Pallets": row.qtyPallets,
      "Approx Wt of load": row.approxWeightLoad,
      "Transit days": row.transitDays,
      "Anticipated Pick Up / ship Date": row.anticipatedPickupDate,
      "Actual Pick Up / ship Date": row.pickupDate,
      "Anticipated Delivery Date": row.anticipatedDeliveryDate,
      "ACTUAL Delivery Date": row.deliveryDate,
      "BOL No": row.bol,
      "CHR No": row.chr,
      "Delivery Type": row.deliveryType,
      "Delivery Tracking Code": row.deliveryTrackingCode,
      "Notes": row.notes,
      "Last Updated": row.lastEdited
    });
  });

  return rows;
}

export function formatSnapshot(results) {
  let rows = [];

  results.forEach(row => {
    console.log(row);
    rows.push({
      'Customer Name': row.accountName,
      'Allocated ID': row.id,
      'Allocation Status': row.allocatedOrderStatus,
      /*
      'Product Name': row.productName,
      'Qty': row.productQty,
      */
      'Product Type': row.productTypeName,
      'Est Ship Date': row.anticipatedPickupDate,
      'Actual Ship Date': row.pickupDate,
      'Est Arrival Date': row.anticipatedDeliveryDate,
      'Actual Arrival Date': row.deliveryDate,
      'Delivery Tracking Code': row.deliveryTrackingCode,
      'CHR Tracking': row.chr,
      'PO Needed?': row.poRequired,
      'PO Number': row.poNum      
    });
  });

  return rows;
}

export function isNumUndefined(obj, row) {
  if (obj === undefined) {
    return "";
  } else if (isNaN(obj)) {
    console.log('OrderID: %o | AllocatedOrder: %o | ProductID: %o', row.orderId, row.allocatedOrderId, row.productId);
    return 0;
  }

  return obj;
}

/*
let prodStarting = {};

  products.forEach((item) => {
    let simpleItem = {
      [item.title]: 0
    };

    let check = results.find(x => x.items.find(xi => (xi.product_id == item.id)));
    
    if (typeof check !== "undefined") {
      prodStarting = {...prodStarting, ...simpleItem};
    }
  });

  results.forEach((row) => {
    let entry = {};

    let prods = prodStarting;
    
    row.items.forEach((item) => {
      let name = products.find(product => product.id == item.product_id).title;
      prods[name] = item.qty;
    });

*/

export function formatAllocatedOrders(results, products) {
  let rows = [];

  let prodStarting = [];

  products.forEach((item) => {
    let simpleItem = {
      [item.title]: 0
    };

    let check = results.find(x => x.items.find(xi => (xi.product_id == item.id)));
    
    if (typeof check !== "undefined") {
      prodStarting.push(item.title);
    }
  });

  prodStarting.sort();

  results.forEach((row) => {
    let entry = {};
    let prods = {};

    prodStarting.forEach((itemName) => {
      let simpleItem = {
        [itemName]: ''
      };

      prods = {...prods, ...simpleItem};
    });

    row.items.forEach((item) => {
      let name = products.find(product => product.id == item.product_id)?.title || 'Product not found.';
      prods[name] = item.qty;
    });

    const orderedProds = {};
    Object.keys(prods).sort().forEach(key => {
      orderedProds[key] = prods[key];
    });

    entry = {
      "ARIQ Order ID": row.orderReference,
      "ARIQ Allocated Order ID": row.id,
      "Account Name": row.accountName,
      "Regional Manager": row.accountManager,
      "Bill-To ID": row.billToId,
      "Ship-To ID": row.shipToId,
      "Delivery Location": row.shipTo,
      "Ship-To Name": row.accountName,
      "Ship-To Address": row.shipToAddress,
      "Ship-To City": row.shipToCity,
      "Ship-To State": row.shipToState,
      "Ship-To Zip": row.shipToZip,
      "Receiving Contact Name": row.receivingContactName,
      "Receiving Contact Phone": row.receivingContactPhone,
      "Receiving Contact Email": row.receivingContactEmail,
      "Web Portal": row.webPortal,
      "Delivery Window": row.deliveryWindow,
      "Allocated Date": row.createdOn,
      "Allocation Status": row.allocatedOrderStatus,
      "IS A PO REQUIRED FOR DELIVERY? (YES/NO)": row.poRequired,
      "PO No (if required for delivery)": row.poNum,
      "PO Date for Delivery": row.poDate,
      "Order Instructions": row.instructions,
      "Special Instructions": row.allocationInstructions,
      "HRMS Shipping Code": row.hrmsCode,
      "HRMS Release Number": row.hrmsReleaseNumber,
      "Qty Pallets": row.qtyPallets,
      "Approx Wt of load": row.approxWeightLoad,
      "Transit days": row.transitDays,
      "Anticipated Pick Up / ship Date": row.anticipatedPickupDate,
      "Actual Pick Up / ship Date": row.pickupDate,
      "Anticipated Delivery Date": row.anticipatedDeliveryDate,
      "ACTUAL Delivery Date": row.deliveryDate,
      "BOL No": row.bol,
      "CHR No": row.chr,
      "Delivery Type": row.deliveryType,
      "Delivery Tracking Code": row.deliveryTrackingCode,
      "Notes": row.notes,
      "Last Updated": row.lastEdited,
      ...orderedProds
    };

    rows.push(entry);
  });

  return rows;
}

export function getAllocatedOrdersColumns(columns, products) {
  let prods = [];

  
  // products.sort((a, b) => (a.sku > b.sku) ? 1 : -1);

  products.forEach((item) => {
    let simpleItem = {
      label: item.title,
      field: item.title
    };

    prods.push(simpleItem);
  });

  return prods;
}
